// Tipografía limitada a las tablas del tablero y su detalle.
export const dashboardTableStyles = {
  overflowX: "auto",
  "& thead th > div": {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
    opacity: 1,
    color: "text.secondary",
  },
  "& tbody td": { fontSize: "0.9375rem", lineHeight: 1.55, py: 1.5 },
  "& tbody td > div": { fontSize: "inherit", color: "text.primary" },
  "& tbody td .MuiTypography-root": { fontSize: "inherit" },
  "& tbody td .MuiChip-root": { fontSize: "0.8125rem" },
  "& tbody td .MuiButton-root": { fontSize: "0.8125rem" },
};
